module.exports = __webpack_public_path__ + "static/level0-46fa5dba2b1ad0ee1a20e78d4610ad72.png";